import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { translate } from '../../../base/i18n/functions';
import { updateSettings } from '../../../base/settings/actions';
import ContextMenuItem from '../../../base/ui/components/web/ContextMenuItem';
import { NOTIFY_CLICK_MODE } from '../../../toolbox/constants';
/**
 * Implements a React {@link Component} which displays a button for flipping the local viedo.
 *
 * @augments Component
 */
class FlipLocalVideoButton extends PureComponent {
    /**
     * Initializes a new {@code FlipLocalVideoButton} instance.
     *
     * @param {Object} props - The read-only React Component props with which
     * the new instance is to be initialized.
     */
    constructor(props) {
        super(props);
        // Bind event handlers so they are only bound once for every instance.
        this._onClick = this._onClick.bind(this);
    }
    /**
     * Implements React's {@link Component#render()}.
     *
     * @inheritdoc
     * @returns {null|ReactElement}
     */
    render() {
        const { className, t } = this.props;
        return (React.createElement(ContextMenuItem, { accessibilityLabel: t('videothumbnail.flip'), className: 'fliplink', id: 'flipLocalVideoButton', onClick: this._onClick, text: t('videothumbnail.flip'), textClassName: className }));
    }
    /**
     * Flips the local video.
     *
     * @private
     * @returns {void}
     */
    _onClick() {
        const { _localFlipX, dispatch, notifyClick, notifyMode, onClick } = this.props;
        notifyClick?.();
        if (notifyMode === NOTIFY_CLICK_MODE.PREVENT_AND_NOTIFY) {
            return;
        }
        onClick?.();
        dispatch(updateSettings({
            localFlipX: !_localFlipX
        }));
    }
}
/**
 * Maps (parts of) the Redux state to the associated {@code FlipLocalVideoButton}'s props.
 *
 * @param {Object} state - The Redux state.
 * @private
 * @returns {IProps}
 */
function _mapStateToProps(state) {
    const { localFlipX } = state['features/base/settings'];
    return {
        _localFlipX: Boolean(localFlipX)
    };
}
export default translate(connect(_mapStateToProps)(FlipLocalVideoButton));
